import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";
import {
  MRT_ColumnPinningState,
  MRT_ColumnFiltersState,
} from "material-react-table";

const clearAction = createAction("clear");

interface Sorting {
  table: { id: string; desc: boolean };
  queryParameter: string;
}
interface FilterItem {
  filter?: string | null;
  dateRange?: [string | null, string | null];
  includeTestCompanies?: boolean;
  sorting?: Sorting | null;
  columnPinning?: MRT_ColumnPinningState;
  columnFilters?: MRT_ColumnFiltersState;
  anchorDataOverviewTemplateIds?: string[];
}
interface TableConfigState {
  [entity: string]: FilterItem;
}

const initialState: TableConfigState = {};

const tableConfig = createSlice({
  name: "tableConfig",
  initialState,
  reducers: {
    setAdditionalFilteringParameters: (
      state,
      action: PayloadAction<{ entity: string; filters: FilterItem }>
    ) => {
      const { entity, filters } = action.payload;
      state[entity] = {
        ...state[entity],
        ...filters,
      };
    },
    clearEntityFilteringParameters: (
      state,
      action: PayloadAction<{ entity: string }>
    ) => {
      delete state[action.payload.entity];
    },
    clearAdditionalFilteringParameters: (
      state,
      action: PayloadAction<{ entity: string }>
    ) => {
      const entityConfig = state[action.payload.entity];
      if (!entityConfig) return;

      delete entityConfig.filter;
      delete entityConfig.dateRange;
      delete entityConfig.includeTestCompanies;
    },
    setTableColumnPinning: (
      state,
      action: PayloadAction<{ entity: string; pinning: MRT_ColumnPinningState }>
    ) => {
      const { entity, pinning } = action.payload;
      if (!state[entity]) {
        state[entity] = {};
      }
      state[entity].columnPinning = pinning;
    },
    setTableColumnFiltering: (
      state,
      action: PayloadAction<{ entity: string; filters: MRT_ColumnFiltersState }>
    ) => {
      const { entity, filters } = action.payload;
      if (!state[entity]) {
        state[entity] = {};
      }
      state[entity].columnFilters = filters;
    },
    setAnchorDataOverviewTemplateIds: (
      state,
      action: PayloadAction<{ entity: string; templateIds: string[] }>
    ) => {
      const { entity, templateIds } = action.payload;
      if (!state[entity]) {
        state[entity] = {};
      }
      state[entity].anchorDataOverviewTemplateIds = templateIds;
    },
    clearAnchorDataOverviewTemplateIds: (
      state,
      action: PayloadAction<{ entity: string }>
    ) => {
      const { entity } = action.payload;
      if (!state[entity]) {
        return;
      }
      delete state[entity].anchorDataOverviewTemplateIds;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(clearAction, () => initialState);
  },
});

export const {
  setAdditionalFilteringParameters,
  clearEntityFilteringParameters,
  clearAdditionalFilteringParameters,
  setTableColumnPinning,
  setTableColumnFiltering,
  setAnchorDataOverviewTemplateIds,
  clearAnchorDataOverviewTemplateIds,
} = tableConfig.actions;
export { clearAction };
export default tableConfig.reducer;
